module.exports = __webpack_public_path__ + "img/comic_photo.843b1e6e.jpg";